import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { AdminPanel } from '../../components/attribute-engine/components/AdminPanel';

export default function AttributeEngineScreen({ onClose, theme }) {
  const isDark = theme === 'dark';
  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', background: isDark ? '#0a0a0a' : '#f1f5f9' }}>
      {/* Back bar */}
      {onClose && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '8px 16px', flexShrink: 0,
          background: isDark ? '#111' : '#fff',
          borderBottom: `1px solid ${isDark ? '#222' : '#e2e8f0'}`
        }}>
          <button
            data-testid="attribute-engine-back-btn"
            onClick={onClose}
            style={{
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '5px 12px', borderRadius: 8, border: 'none', cursor: 'pointer',
              fontSize: 12, fontWeight: 700,
              background: isDark ? '#1e1e1e' : '#f1f5f9',
              color: isDark ? '#94a3b8' : '#475569',
              transition: 'background 0.15s'
            }}
            onMouseEnter={e => { if (!e.currentTarget) return; e.currentTarget.style.background = isDark ? '#2a2a2a' : '#e2e8f0'; }}
            onMouseLeave={e => { if (!e.currentTarget) return; e.currentTarget.style.background = isDark ? '#1e1e1e' : '#f1f5f9'; }}
          >
            <ArrowLeft size={14} />
            Back to Hub
          </button>
          <span style={{ fontSize: 13, fontWeight: 800, color: isDark ? '#e2e8f0' : '#0f172a' }}>
            Attribute Engine Admin
          </span>
        </div>
      )}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        <AdminPanel />
      </div>
    </div>
  );
}
